import styled from "styled-components";
import Colors from "../../../shared/colors";

export default styled.div`

  .status-cell-with-tooltip {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    flex-wrap: nowrap;
  }

  .tooltip-status {
    position: relative;
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
  }

  .tooltip-status .info-icon {
    width: 16px;
    height: 16px;
    display: block;
    cursor: pointer;
  }

  /* Above the trigger so the table scroll container (overflow-x-auto → overflow-y auto)
     does not grow when the last row shows a tooltip. High z-index paints over rows/cells. */
  .tooltip-status .tooltiptext-status {
    display: none;
    width: fit-content;
    background-color: ${Colors.white};
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
    color: ${Colors.emperor};
    text-align: center;
    border-radius: 6px;
    padding: 10px 21px;
    position: absolute;
    z-index: 9999;
    left: 50%;
    bottom: calc(100% + 8px);
    top: auto;
    transform: translateX(-50%);
    font-weight: normal;
    pointer-events: none;
    white-space: nowrap;
  }

  .tooltip-status .tooltiptext-status::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: ${Colors.white} transparent transparent transparent;
  }

  .tooltip-status:hover .tooltiptext-status {
    display: block;
  }

  
`;